import { jsPDF } from "jspdf";

export function generateChallanPdf(orderId, order, hsnSummary, totals, company) {
  
  
 company = company || {};

  
  const pdf = new jsPDF("landscape", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();


  // -------------------------------
  // HEADER (Company Details)
  // -------------------------------
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text(company.name || "", pageWidth / 2, 12, { align: "center" });

  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");
  pdf.text(company.address1 || "", pageWidth / 2, 18, { align: "center" });
  pdf.text(company.address2 || "", pageWidth / 2, 24, { align: "center" });
  pdf.text(`Tel: ${company.phone || ""}`, pageWidth / 2, 30, { align: "center" });
  pdf.text(`GSTIN: ${company.gstin || ""}`, pageWidth / 2, 36, { align: "center" });

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(13);
  pdf.text("DELIVERY CHALLAN", pageWidth / 2, 44, { align: "center" });

order = order || {};              // <---- ADD THIS
order.partyName = order.partyName || "";  // <---- ADD THIS
order.vehicleno = order.vehicleNo || "-"; // <---- ADD THIS


  // ---------------------------------------
  // BASIC DETAILS SECTION
  // ---------------------------------------
  pdf.setFillColor(240, 200, 210);
  pdf.rect(10, 50, pageWidth - 20, 25, "F");

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.text("DC No:", 14, 58);
  pdf.setFont("helvetica", "normal");
  pdf.text(orderId, 35, 58);



  pdf.setFont("helvetica", "bold");
  pdf.text("Party:", 14, 66);
  pdf.setFont("helvetica", "normal");
  pdf.text(order.partyName || "", 35, 66);

  pdf.setFont("helvetica", "bold");
  pdf.text("Order Date:", pageWidth / 2 + 10, 58);
  pdf.setFont("helvetica", "normal");
  
  
  const finalDate = order.orderDateOnly
  ? new Date(order.orderDateOnly).toLocaleDateString("en-IN")
  : "-";

pdf.text(finalDate, pageWidth / 2 + 38, 58);

  
  

  pdf.setFont("helvetica", "bold");
  pdf.text("Vehicle No:", pageWidth / 2 + 10, 66);
  pdf.setFont("helvetica", "normal");
  pdf.text(order.vehicleNo || "-", pageWidth / 2 + 38, 66);

  // Reverse Charge
  pdf.setFont("helvetica", "bold");
  pdf.text("Reverse Charge (Y/N):", 14, 74);
  pdf.setFont("helvetica", "normal");
  pdf.text("N", 60, 74);

  // ---------------------------------------
  // FROM / TO SECTION
  // ---------------------------------------
  pdf.setFillColor(220, 220, 255);
  pdf.rect(10, 80, pageWidth - 20, 20, "F");

  pdf.setFont("helvetica", "bold");
  pdf.text("FROM", 14, 87);
  pdf.setFont("helvetica", "normal");
  pdf.text("State: KARNATAKA     Code: 29", 14, 95);

  pdf.setFont("helvetica", "bold");
  pdf.text("TO", pageWidth / 2 + 10, 87);
  pdf.setFont("helvetica", "normal");
  pdf.text("State: KARNATAKA     Code: 29", pageWidth / 2 + 10, 95);

  // ---------------------------------------
  // PLACE OF SUPPLY
  // ---------------------------------------
  pdf.setFont("helvetica", "bold");
  pdf.text("Place of Supply:", 14, 110);

  pdf.setFont("helvetica", "normal");
  pdf.text("BANGALORE LOCAL AREA LINE SALES", 55, 110);
  pdf.text("State: KARNATAKA   Code: 29", 55, 116);

  // ---------------------------------------
  // TABLE HEADER
  // ---------------------------------------
  let y = 128;

  pdf.setFillColor(230, 200, 230);
  pdf.rect(10, y - 6, pageWidth - 20, 8, "F");

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);

  pdf.text("S.No", 12, y,{ align: "left" });
  pdf.text("Product", 28, y,{ align: "center" });
  pdf.text("HSN", 75, y,{ align: "center" });
  pdf.text("Qty", 102, y,{ align: "center" });
  pdf.text("Basic", 120, y,{ align: "center" });
  pdf.text("GST", 145, y,{ align: "center" });
  pdf.text("Cess", 165, y,{ align: "center" });
  pdf.text("Addl Cess", 185, y,{ align: "center" });
  pdf.text("Amount", 210, y,{ align: "center" });

  // ---------------------------------------
  // TABLE BODY (SAFE VALUES)
  // ---------------------------------------
  pdf.setFont("helvetica", "normal");

  const hsnList = Object.keys(hsnSummary);
  let index = 1;

  y += 8;

  hsnList.forEach((hsn) => {
    const r = hsnSummary[hsn] || {
      qty: 0,
      basic: 0,
      gstAmt: 0,
      cessAmt: 0,
      addlAmt: 0,
      total: 0,
    };

    pdf.text(String(index), 12, y);
    pdf.text(String(r.description || "CIGARETTES"), 28, y,{ align: "center" });
    pdf.text(hsn, 75, y,{ align: "center" });

    pdf.text(Number(r.qty || 0).toFixed(2), 102, y, { align: "center" });
    pdf.text(Number(r.basic || 0).toFixed(2), 120, y, { align: "center" });
    pdf.text(Number(r.gstAmt || 0).toFixed(2), 145, y, { align: "center" });
    pdf.text(Number(r.cessAmt || 0).toFixed(2), 165, y, { align: "center" });
    pdf.text(Number(r.addlAmt || 0).toFixed(2), 185, y, { align: "center" });
    pdf.text(Number(r.total || 0).toFixed(2), 210, y, { align: "center" });

    y += 8;
    index++;
  });

  // TOTAL ROW (better alignment)
pdf.setFillColor(255, 220, 220);
pdf.rect(10, y - 6, pageWidth - 20, 8, "F");

pdf.setFont("helvetica", "bold");
pdf.text("TOTAL", 28, y);

// Synchronized x positions for perfect alignment with body rows (align: center)
pdf.text(Number(totals.totalQty || 0).toFixed(2), 102, y, { align: "center" });
pdf.text(Number(totals.totalBasic || 0).toFixed(2), 120, y, { align: "center" });
pdf.text(Number(totals.totalGST || 0).toFixed(2), 145, y, { align: "center" });
pdf.text(Number(totals.totalCESS || 0).toFixed(2), 165, y, { align: "center" });
pdf.text(Number(totals.totalAddlCess || 0).toFixed(2), 185, y, { align: "center" });
pdf.text(Number(totals.grandTotal || 0).toFixed(2), 210, y, { align: "center" });

  // ---------------------------------------
  // SIGNATURE
  // ---------------------------------------
  const signY = pageHeight - 25;

pdf.setFont("helvetica", "bold");
pdf.text(company.name || "", pageWidth - 35, signY, { align: "center" });

pdf.setFont("helvetica", "normal");
pdf.text("(AUTHORIZED SIGNATORY)", pageWidth - 35, signY + 7, { align: "center" });

  return pdf;
}
